import {SET_SOCIAL_LINKS} from "../ActionTypes";

export const setSocialLinks = (sociallinks) => ({
  type: SET_SOCIAL_LINKS,
  payload: sociallinks
})